
import VehicleModelContainer from "../VehicleModel/VehicleModelContainer";
import VehicleModelStore from "./VehicleModelStore";


export default VehicleModelStore(VehicleModelContainer);